import { IiXRHrData as IClientSpecificData } from '@clients/ek/interfaces';

export const processIXRHrData = (data: IClientSpecificData) => {
  return Object.fromEntries(
    Object.entries(data).map(([key, value]) => [
      key,
      value && typeof value === 'string' ? value.toUpperCase() : value,
    ]),
  );
};
